import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import { createPinia } from 'pinia'
import Popper from 'vue3-popper'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { createI18n } from 'vue-i18n'

const pinia = createPinia()

const messages = {
  en: require('./locales/en.json'),
  ro: require('./locales/ro.json')
}

const i18n = createI18n({
  locale: 'ro',
  fallbackLocale: 'ro',
  messages
})

createApp(App)
  .use(pinia)
  .use(router)
  .use(Toast)
  .use(i18n)
  .component('Popper', Popper)
  .mount('#app')
